import { Component, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'md-init-page',
  imports: [MatProgressSpinnerModule],
  templateUrl: './init-page.component.html',
  styleUrl: './init-page.component.scss'
})
export class InitPageComponent implements OnInit {
  constructor(
    private oidcSecurityService: OidcSecurityService,
    private router: Router
  ) {}

  ngOnInit() {
    this.oidcSecurityService.isAuthenticated().subscribe(isAuthenticated => {
      if (isAuthenticated) {
        this.router.navigate(['app']);
      } else {
        this.router.navigate(['login']);
      }
    });
  }
}
